import React from "react";
import "./StateBadge.css";

/**
 * 思维状态徽章。
 *
 * 不是分数，不是奖牌——是导师对学生当下思维状态的一句"我看到你在哪儿了"。
 * 五种状态在视觉上都是平等的（中性色调差异，无好坏排序）。
 *
 * Props:
 *   state: { name: string, label: string, meta: { emoji, tone, aria } }
 */
const StateBadge = ({ state }) => {
  if (!state || !state.meta) return null;
  const { name, label, meta } = state;
  return (
    <div
      className={`state-badge state-badge--${meta.tone}`}
      role="note"
      aria-label={`${meta.aria}：${label}`}
    >
      <span className="state-badge__emoji" aria-hidden="true">{meta.emoji}</span>
      <span className="state-badge__name">{name}</span>
      {label ? (
        <>
          <span className="state-badge__sep" aria-hidden="true">·</span>
          <span className="state-badge__label">{label}</span>
        </>
      ) : null}
    </div>
  );
};

export default React.memo(StateBadge);
